<div class="modal-advise-container">
  <p class="title-advice alt-inter-bold alt-size-14 alt-color-grayscale1">{{"OPORTUNITIES.changeChip" | translate}}
  </p>
  <p class="text-advertising alt-inter-medium alt-size-12 alt-color-grayscale1 ">{{"OPORTUNITIES.changeChipAdvertising"
    | translate }}</p>
  <div class="btn-container">
    <div class="alt-row-align-center">
      <button class="close-btn" type="button">
        <p class="close-btn-text alt-inter-medium alt-size-12 alt-color-bran1" (click)="closeModal(false)">
          {{"OPORTUNITIES.dontChange" | translate | uppercase}}</p>
      </button>
      <button class="change-btn" type="button">
        <p class="change-btn-text alt-inter-medium alt-size-12 alt-color-bran1" (click)="closeModal(true)">
          {{"OPORTUNITIES.change" | translate | uppercase}}</p>
      </button>
    </div>
  </div>
</div>
